import { Stack } from '@festina-life/ui/structure'
import cx from 'classnames'
import { useMemo } from 'react'

import { useMetaModelContext } from '../../context/metaModelContext'
import { collectAllNodesFromTree } from '../../uiModels/api/metaModel/helpers'
import { BlockScopedOperationsWithErrors } from './BlockScopedOperationsWithErrors'
import type { OperationsListVariant } from './types'

type Props = {
  variant: OperationsListVariant
  className?: string
}

export const OperationsWithErrors = ({ variant, className }: Props) => {
  const { blockTopology } = useMetaModelContext()
  const allBlocks = useMemo(
    () => (blockTopology ? collectAllNodesFromTree(blockTopology) : []),
    [blockTopology],
  )

  return (
    <Stack className={cx('flex-col', className)}>
      {allBlocks.map((block) => (
        <BlockScopedOperationsWithErrors
          block={block}
          key={block}
          variant={variant}
        />
      ))}
    </Stack>
  )
}
